import { Centered } from '@prophecy/ui-v3/Layout';
import { Spinner } from '@prophecy/ui-v3/Spinner';
import { toast } from '@prophecy/ui-v3/Toast';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { discourseOauth } from '../../data/apis/api';

export default function DiscourseOauth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const client_id = searchParams.get('client_id');
  const redirect_uri = searchParams.get('redirect_uri');
  const response_type = searchParams.get('response_type');
  const state = searchParams.get('state');

  const handleDiscourseOauth = usePersistentCallback(async () => {
    try {
      const response = (await discourseOauth({
        client_id: client_id || '',
        redirect_uri: redirect_uri || '',
        response_type: response_type || '',
        state: state || ''
      })) as unknown as { success: boolean; redirectUrl: string; message: string };

      if (response.success) {
        // redirect to discourse login page
        window.location.href = decodeURIComponent(response.redirectUrl);
      } else {
        toast.error({ content: response.message, 'data-test-id': 'discourse-sso-error' });
      }
    } catch (error) {
      toast.error({ content: 'Failed to authenticate with Discourse', 'data-test-id': 'discourse-sso-error' });
    }
  });

  useEffect(() => {
    if (!client_id || !redirect_uri || !response_type || !state) {
      // redirect to home page if any of the params are not present
      navigate('/');
      return;
    } else {
      handleDiscourseOauth();
    }
  }, [client_id, redirect_uri, response_type, state, navigate, handleDiscourseOauth]);

  return (
    <Centered>
      <Spinner spinning />
    </Centered>
  );
}
